module.exports = __webpack_public_path__ + "static/rawpixel-252130-unsplash-41ddecaf5845472fdf05c4b0d16ee9bf.jpg";